import { listUserGroupsAPI } from '@/service';
import { useQuery } from '@tanstack/react-query';

const groupBaseQueryKey = ['group'];
const groupQueryKey = [...groupBaseQueryKey];

const groupsFetchFunction = listUserGroupsAPI;

export const useGroupQuery = () => {
  return useQuery({
    queryKey: groupQueryKey,
    queryFn: groupsFetchFunction,
  });
};
